// ── RISOLUZIONE VARIABILI ────────────────────────────────────────────────────

import { PdfInfo } from './pdf-types';

const MONTHS_IT = [
  'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno',
  'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre',
];

const MONTHS_EN = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

export function getMonthName(m: number, lang: string): string {
  return lang === 'it' ? MONTHS_IT[m - 1] : MONTHS_EN[m - 1];
}

function formatDate(dateStr: string, lang: string): string {
  const parts = dateStr.split('-');
  if (parts.length !== 3) return dateStr;
  const [y, m, d] = parts;
  if (lang === 'it') return `${d} ${MONTHS_IT[+m - 1]} ${y}`;
  return `${MONTHS_EN[+m - 1]} ${d}, ${y}`;
}

function methodLabel(m: string | undefined, lang: string): string {
  if (lang === 'it') {
    if (m === 'cash') return 'in contanti';
    if (m === 'transfer') return 'tramite bonifico';
    if (m === 'both') return 'in contanti o tramite bonifico';
  } else {
    if (m === 'cash') return 'in cash';
    if (m === 'transfer') return 'by bank transfer';
    if (m === 'both') return 'in cash or by bank transfer';
  }
  return m ?? '';
}

function calcTotal(customer_data: any): number {
  const services = (customer_data.event?.services ?? []).filter((s: any) => s.selected);
  return services.reduce((s: number, i: any) => s + (+i.price || 0), 0);
}

export function resolveVariables(
  text: string,
  customer_data: any,
  contract_info: PdfInfo,
  lang: string,
): string {
  if (!text) return '';
  const pay = contract_info.payment;
  const total = calcTotal(customer_data);
  const dateStr = customer_data.event?.date ?? '';
  const dateFormatted = formatDate(dateStr, lang);

  return text
    .replace(/\{\{nome_sposa\}\}/g, customer_data.client?.name ?? '')
    .replace(/\{\{cognome_sposa\}\}/g, customer_data.client?.lastname ?? '')
    .replace(/\{\{data_matrimonio\}\}/g, dateFormatted)
    .replace(/\{\{location\}\}/g, customer_data.event?.location ?? '')
    .replace(/\{\{acconto\}\}/g, pay ? (pay.deposit_type === 'percent' ? `${pay.deposit_amount}%` : `€${pay.deposit_amount}`) : '')
    .replace(/\{\{totale\}\}/g, `€${total.toFixed(2)}`)
    .replace(/\{\{metodo_acconto\}\}/g, methodLabel(pay?.deposit_method, lang))
    .replace(/\{\{metodo_saldo\}\}/g, methodLabel(pay?.final_payment_method, lang))
    .replace(/\{\{nome_studio\}\}/g, contract_info.business_name ?? '');
}

export { formatDate, methodLabel, calcTotal };
